const Loading = () => <div className='loading'><span></span></div>

export default Loading